import { IconButton, IconButtonProps, SxProps, Theme } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import React from 'react'

type RcmDialogCloseIconProps = {
  sx?: SxProps<Theme>
  ariaLabel?: string
  onClick: () => void
} & IconButtonProps

const RcmDialogCloseIcon: React.FC<RcmDialogCloseIconProps> = ({ sx, onClick, ariaLabel, ...rest }) => {
  return (
    <IconButton
      aria-label={ariaLabel}
      onClick={onClick}
      sx={{
        position: 'absolute',
        right: 8,
        top: 8,
        color: (theme) => theme.palette.grey[500],
        ...sx
      }}
      {...rest}
    >
      <CloseIcon />
    </IconButton>
  )
}

export default RcmDialogCloseIcon
